import "./checkbox.css";
import Sunglasses from "../../../assets/images/sunglasses.png";
import {CheckCircleFilled, CheckOutlined} from "@ant-design/icons";
import Check from "../../../assets/icons/check.png";
import {Tooltip} from "antd";
import {useEffect, useRef, useState} from "react";

export enum CheckboxSizeOptions {
    normal = 'normal',
    big = 'big'
}

interface CheckboxProps {
    label: string;
    isSelected: boolean;
    setIsSelected: (newState: boolean) => void;
    size?: CheckboxSizeOptions;
    imageUrl?: string;
    description?: string;
    disabled?: boolean;
    disabledReason?: string;
    tooltip?: string;
    tooltipPlacement?: "top" | "right" | "left" | "bottom"
}

const Checkbox = ({ label, isSelected, setIsSelected, size = CheckboxSizeOptions.normal, imageUrl, description = '', disabled = false, disabledReason = '', tooltip = '', tooltipPlacement }: CheckboxProps) => {
    const labelRef = useRef<HTMLDivElement | null>(null);
    const [tooltipText, setTooltipText] = useState('');

    useEffect(() => {
        if((labelRef.current?.scrollHeight || 0) > (labelRef.current?.clientHeight || 0)) {
            setTooltipText(label);
        }
    }, [label]);

    return (
        <div className="field-container">
            <Tooltip placement={tooltipPlacement || "top"} title={`${tooltipText ? `${tooltipText}. ` : ''}${disabled ? disabledReason : ""}`}>
                <div onClick={() => !disabled && setIsSelected(!isSelected)} className={`checkbox-container ${size} ${imageUrl ? 'with-image' : ''} ${isSelected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}>

                    {imageUrl ?
                        <img src={imageUrl} className="checked-image" /> :
                        <div className="square"><div className="checked"><img src={Check} className="checked-icon" /></div></div>
                    }
                    <div className="checkbox-content">
                        <div className="right">
                            <div className="checkbox-content-inner">
                                <div className="label" ref={labelRef}>{label}</div>
                                <div className="description">{description}</div>
                            </div>
                            {imageUrl ? <CheckCircleFilled className="image-checkbox" /> : null}
                        </div>
                    </div>

                </div>
            </Tooltip>
        </div>
    )
}

export default Checkbox;